// extracted by mini-css-extract-plugin
export default {"form":"genres_form__zpjSl","selectField":"genres_selectField__rFWPb","table":"genres_table__8sZNZ","subgenreTable":"genres_subgenreTable__3cLbI"};